import { render, staticRenderFns } from "./MultipleQuiz.vue?vue&type=template&id=0de67543&scoped=true&"
import script from "./MultipleQuiz.vue?vue&type=script&lang=js&"
export * from "./MultipleQuiz.vue?vue&type=script&lang=js&"
import style0 from "./MultipleQuiz.vue?vue&type=style&index=0&id=0de67543&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de67543",
  null
  
)

export default component.exports